import React, { Suspense } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { currentInstance} from '../utils';
const adminLogin = React.lazy(() => import('../pages/admin/login'));
const adminLayout = React.lazy(() => import('../pages/admin/layout'));

const userLogin = React.lazy(() => import('../pages/customer/'+ currentInstance.name +'/login'));
const userRegister = React.lazy(() => import('../pages/customer/'+ currentInstance.name +'/register'));
const userActivate = React.lazy(() => import('../pages/customer/'+ currentInstance.name +'/activate'));
const userVerifyEmail=React.lazy(() => import('../pages/customer/'+ currentInstance.name +'/verify-email'));
const userPasswordReset=React.lazy(() => import('../pages/customer/'+ currentInstance.name +'/reset-password'));
const userLayout = React.lazy(() => import('../pages/customer/'+ currentInstance.name +'/layout'));
const userPublicLayout = React.lazy(() => import('../pages/customer/'+ currentInstance.name +'/public-layout'));
const myroutes = () => (
  <HashRouter>
    <Suspense fallback={<div className="text-center" style={{ marginTop: 'calc(30vh)' }} ><Spinner animation="border" /></div>}>
      <Switch>
        <Route path="/:userId/admin" component={adminLayout} />
        <Route path="/admin-login" component={adminLogin} />
        <Route path="/:userId/customer" component={userLayout} />
        <Route path="/public" component={userPublicLayout} />
        <Route path="/member-login" component={userLogin} />
        <Route path="/member-register" component={userRegister} />
        <Route path="/activate-member/:memberId" component={userActivate} />
        <Route path="/member-verify-email" component={userVerifyEmail} />
        <Route path="/member-reset-password" component={userPasswordReset} />
      </Switch>
    </Suspense>
  </HashRouter>

);
export default myroutes;
